import { qbTimeAgo } from '@core/util/util.qbTimeAgo';
import { timeAgo } from '@core/util/util.timeAgo';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@frontend/components/ui/tooltip';
import { QuestionContext } from '@frontend/shared/components/Question/QuestionContext';
import { useRequiredContext } from '@frontend/shared/hooks/useRequiredContext';
import { useSingleSearchParam } from '@frontend/shared/hooks/useSingleSearchParam';

export function QuestionSorter() {
  const question = useRequiredContext(QuestionContext);
  const [q] = useSingleSearchParam('q');

  let text = '';
  let tooltipLabel = '';

  if (!q) {
    const createdAgo = timeAgo(question.created_at) ?? '';
    const createdDate = new Intl.DateTimeFormat().format(
      new Date(question.created_at),
    );
    const createdShort = qbTimeAgo(question.created_at) ?? '';

    text = createdShort;
    tooltipLabel = `Asked ${createdAgo} (${createdDate})`;
  }

  if (!text) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="flex items-center flex-none mr-1.5">
          {text && (
            <span className="text-[13px] font-medium tracking-[-0.01em] text-[rgba(3,52,38,0.6)]">
              {text}
            </span>
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent side="bottom" align="end">
        {tooltipLabel}
      </TooltipContent>
    </Tooltip>
  );
}
